import {
  ClientAppEvent,
  DATA_PRODUCT_DEMO_HOWDYGO_PUBLICATION_ID,
} from "constants/index";

import { HowdyGoDemoPage } from "../HowdyGoDemoPage";

interface AnalyticsPackageUnactivatedPageProps {
  isDemoParticipant?: boolean;
}

const DEMO_HEADLINE =
  "This is sample analytics data so you can explore how Evotrux reporting works.";

export function AnalyticsPackageUnactivatedPage(
  props: AnalyticsPackageUnactivatedPageProps,
) {
  const { isDemoParticipant = false } = props;

  return (
    <HowdyGoDemoPage
      publicationId={DATA_PRODUCT_DEMO_HOWDYGO_PUBLICATION_ID}
      event={ClientAppEvent.DATA_PAGE_DEMO_VIEWED}
      visitedUrl="/shippers/data"
      demoHeadline={DEMO_HEADLINE}
      isDemoParticipant={isDemoParticipant}
    />
  );
}
